import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-801bae56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container max-w-2xl mx-auto" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Virtual Ward ")
const _hoisted_4 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Log in with email ")
const _hoisted_7 = { class: "bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, { id: "login-page" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "text-xl font-semibold text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "mb-2 ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          id: "userlogin",
                          src: _ctx.userFull,
                          class: "w-12 h-12 mx-auto mb-2",
                          role: "presentation",
                          alt: ""
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_BaseCard, { class: "flex items-center h-auto m-4 mt-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, { class: "flex flex-col ion-no-padding" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          type: "email",
                          modelValue: _ctx.user.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
                          placeholder: "Email"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.errors['email'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errors.email[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_IonButton, {
                color: "primary",
                expand: "block",
                fill: "solid",
                onClick: _withModifiers(_ctx.sendMagicLink, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ion_icon, {
              id: "bp-logo",
              src: _ctx.bigPicture
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_loading, {
        "is-open": _ctx.isLoadingRef,
        message: _ctx.loadingMessageRef,
        onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLoading(false)))
      }, null, 8, ["is-open", "message"])
    ]),
    _: 1
  }))
}